import React from 'react'
import { useState } from 'react'
import axios from 'axios'

const Login = (props) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    // const [checked, setchecked] = useState(false)

    const handleLogin = async () => {
      try {
        const response = await axios.post('http://your-api-url/api/login', {
          username: username,
          password: password
        });
        // Handle successful login, e.g., set a token in local storage, redirect, etc.
      } catch (error) {
        // Handle login error, e.g., show error message
        console.error('Login failed:', error);
      }
    };
    
    const handleReset = async () => {}
    // const handleChange = (param) => {
    //     setchecked(!checked)
    //     debugger;
    //     setTimeout(() => {
    //         props.setActive(props.Active + 1)
    //     }, 400);
    // }

  return (
    <div className={`slide-in-elliptic-top-fwd flex flex-col gap-6 items-center bg-pink-500/30 backdrop-blur-[6px] w-fit mx-auto p-[3rem] rounded-2xl`}>
      <h1 className='text-[2.4rem] font-extrabold'>
        Login
      </h1>
      <div className='flex flex-col gap-2'>
        <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Username" className='min-w-[20rem] border rounded-md text-sm outline-none lg:px-4 px-2 lg:py-3 py-[0.6rem] placeholder:text-[#A1A1A1] text-[#101928] focus:border-[#8f8f8f] ease-in transition-all bg-white' />
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className='min-w-[20rem] border rounded-md text-sm outline-none lg:px-4 px-2 lg:py-3 py-[0.6rem] placeholder:text-[#A1A1A1] text-[#101928] focus:border-[#8f8f8f] ease-in transition-all bg-white' />
      </div>
      <div className='display: flex;'>
        <button onClick={handleReset} className='hover:bg-[#D55AA3] border border-white px-6 py-2 rounded-lg transition-all bg-white text-[#D55AA3] ease-out font-semibold text-lg hover:text-white'>Login</button>
        <button onClick={handleLogin} className='hover:bg-[#D55AA3] border border-white px-6 py-2 rounded-lg transition-all bg-white text-[#D55AA3] ease-out font-semibold text-lg hover:text-white'>Reset</button>
      </div>
    </div>
  )
}

export default Login